import * as React from "react";
import { Spin } from "antd";
import CheckboxGroup from "../../components/app/CheckboxGroup";
import { IFormType } from "../../../model/formconfiguration/FormType";

export interface State {}

export interface Props {
  spinnerEnabled?: boolean;
  translate: any;
  formTypes?: IFormType[];
  onFormTypesChange?: any;
  assignedFormTypesCodes?: string[];
}

export default class FormTypesGroupCategoryExpanded extends React.Component<
  Props,
  State
> {
  render() {
    const {
      spinnerEnabled,
      translate,
      formTypes,
      onFormTypesChange,
      assignedFormTypesCodes
    } = this.props;

    return (
      <div>
        <Spin spinning={spinnerEnabled}>
          <h3>{translate("form_types_group_category_extended.title")}</h3>
          <CheckboxGroup
            options={formTypes}
            onChange={onFormTypesChange}
            value={assignedFormTypesCodes}
            columnCount={2}
          />
        </Spin>
      </div>
    );
  }
}
